export default "__VITE_ASSET__CueU7RY4__"